import React, { useEffect, useState } from 'react';

const DEFAULT_PREVIEW_CHARS = 500;

export const COLLAPSIBLE_TEXT_PREVIEW_CHARS = DEFAULT_PREVIEW_CHARS;

export interface CollapsibleTextProps {
  text: string;
  className?: string;
  previewChars?: number;
}

const CollapsibleText: React.FC<CollapsibleTextProps> = ({
  text,
  className = 'eval-evidence__text',
  previewChars = DEFAULT_PREVIEW_CHARS,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const needsTruncate = text.length > previewChars;

  useEffect(() => {
    setIsExpanded(false);
  }, [text]);

  if (!needsTruncate) {
    return <pre className={className}>{text}</pre>;
  }

  const hiddenChars = text.length - previewChars;

  return (
    <div className={`eval-collapsible-text${isExpanded ? ' eval-collapsible-text--expanded' : ''}`}>
      <pre className={className}>{isExpanded ? text : `${text.slice(0, previewChars)}…`}</pre>
      <button
        type="button"
        className="eval-collapsible-text__toggle"
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((value) => !value)}
      >
        {isExpanded
          ? 'Show less'
          : hiddenChars > 0
            ? `Show full text (+${hiddenChars.toLocaleString()} more characters)`
            : 'Show full text'}
      </button>
    </div>
  );
};

export default CollapsibleText;
